export class TelefonoEmpresa{

    TelefonoEmpresaID: number;
    PaisID : string;
    Numero : string;
    Extension : string;
}
